export default __webpack_public_path__ + "static/detailedCta-3880711fd76ef773cc8421432745befd.png";